module.exports = __webpack_public_path__ + "static/img/logo.855ed5b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo.png
// module id = 217
// module chunks = 1